export default function Plus({ ...props }) {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props}>
      <rect width="28" height="28" fill="none" />
      <line
        x2="19.25"
        transform="translate(4.375 14)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        d="M0,0V19.25"
        transform="translate(14 4.375)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </svg>
  );
}
